module.exports = __webpack_public_path__ + "img/icon-video.e69fb48.svg";